// extracted by mini-css-extract-plugin
export default {"wrapper":"DualImage_wrapper__wp82P","image":"DualImage_image__DyWA6"};